import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';
import { TheWoodsPostCardStackContentViewModel } from './the-woods-post-card-stack-content-view-model';

@Component({
  selector: 'app-the-woods-post-card-stack-content',
  templateUrl: './the-woods-post-card-stack-content.component.html',
  styleUrl: './the-woods-post-card-stack-content.component.scss',
  providers: [TheWoodsPostCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TheWoodsPostCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public override viewModel: TheWoodsPostCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
